var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import AccountNavigationItem from './AccountNavigationItem';
import { localizeUrl } from '../../../core/helpers/url-helper';
import { resetUser } from '../../Auth/store/actions';
var mapDispatchToProps = {
    resetUser: resetUser,
};
var connector = connect(null, mapDispatchToProps);
var AccountNavigation = /** @class */ (function (_super) {
    __extends(AccountNavigation, _super);
    function AccountNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountNavigation.prototype.render = function () {
        return (React.createElement("ul", { className: "c-account-navigation" },
            React.createElement(AccountNavigationItem, { label: "account.navigation.orders.navigation.text", url: "/account/orders", icon: "orders" }),
            React.createElement(AccountNavigationItem, { label: "account.navigation.address_list.navigation.text", url: "/account/addresses", icon: "location" }),
            React.createElement(AccountNavigationItem, { label: "account.navigation.profile.navigation.text", url: "/account/profile", icon: "account" }),
            React.createElement("li", { className: "c-account-navigation__item c-account-navigation__item--logout" },
                React.createElement("a", { href: localizeUrl('/auth/logout') },
                    React.createElement("i", { className: "icon-logout" }),
                    React.createElement("span", null, this.props.t('account.navigation.logout.navigation.text'))))));
    };
    return AccountNavigation;
}(React.Component));
export default connector(withTranslation()(AccountNavigation));
